import WarehouseList from '../../components/WarehouseList/WarehouseList';

function Warehouse () {
    return (
      <>
        <WarehouseList />
      </>
    );
  }
  
  export default Warehouse;

